import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: 'En PDF de alta resolución, listo para usar en cualquier dispositivo, proyectar en clase o imprimir. No necesitás ningún programa especial.'
  }, {
    q: '¿Cuánto tarda en llegar después de pagar?',
    a: 'El acceso es inmediato. Recibirás el link de descarga en tu correo en menos de 5 minutos. Si no lo ves en la bandeja principal, revisá spam.'
  }, {
    q: '¿Puedo usar el material en varias divisiones?',
    a: 'Sí. El kit es para uso docente personal en todas las divisiones y grupos que tengas a cargo.'
  }, {
    q: '¿Está adaptado a mi país?',
    a: 'Sí. El kit usa principios financieros universales sin citar leyes ni sistemas específicos de un solo país. Funciona sin modificaciones en cualquier país de habla hispana.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si por cualquier motivo el material no cumple tus expectativas, te devolvemos el 100% de tu dinero. Sin preguntas.'
  }, {
    q: '¿Para qué año de secundaria sirve?',
    a: 'Está diseñado para secundaria y escuela técnica en cualquier año. El docente puede adaptar la profundidad según el nivel del grupo.'
  }, {
    q: '¿Cómo puedo pagar?',
    a: 'El pago es 100% seguro y se procesa en tu moneda local al tipo de cambio del momento. Aceptamos todos los medios de pago disponibles en tu país.'
  }, {
    q: '¿Incluye planificación anual?',
    a: 'Sí. La Plantilla de Planificación Anual completa viene incluida como Bono 1 sin costo adicional.'
  }, {
    q: '¿Sirve si ya empecé el año?',
    a: 'Totalmente. Podés incorporar el material en el punto del año en que estés. Cada tomo es independiente y puede usarse sin haber trabajado los anteriores.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está expresado en dólares estadounidenses (USD) pero el cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-b border-brand-accent/10" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-67">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-68">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-lg border-2 ${openIndex === index ? 'border-brand-accent' : 'border-white/5'} overflow-hidden transition-all duration-200 shadow-lg`} data-id="element-69">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-70">
                <span className={`font-black text-sm md:text-base pr-4 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-71">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-72" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-73" />}
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-74">
                <p className="text-sm md:text-base text-gray-300 leading-relaxed pt-3 border-t border-white/10 font-bold" data-id="element-75">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}